// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tOcB","label":"styles_label__25i0X"};